<template>
	<div class="manage">
		<div style="" class="top">
			<el-row>
				<el-col :span="24">
					<div>
						<div style="float: left;">
						</div>
						<div style="float: left;">
						</div>
						<div style="float: left;">
						</div>
						<div style="float: left;">
						</div>
						<div style="float: left;">
						</div>
						<div style="float: left;">
						</div>
						<div style="float: left;">
						</div>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="table">
					<div ref="height_top" v-bind:style="{ height: tableHeight + 'px' }" style="overflow: auto;">
						<el-card v-for="(item,key) in tableData" style="margin-bottom:20px">
							<el-row>
								<el-col :span="24">
									<div>
										<el-table :data="item.gridData" border :header-cell-style="{'background-color': '#e5e5e5'}" size="small" style="width: 100%">
											<el-table-column property="date" label="现有" width="60" />
											<el-table-column property="brand_name" label="品牌" width="100" show-overflow-tooltip />
											<el-table-column property="name" label="品名" width="100" show-overflow-tooltip />
											<el-table-column property="model" label="型号" show-overflow-tooltip />
											<el-table-column property="order_no" label="订货号" show-overflow-tooltip />
											<el-table-column property="stock_type_txt" label="货物状态" width="160" show-overflow-tooltip />
											<el-table-column property="remark" label="备注" show-overflow-tooltip />
											<el-table-column property="pro_result" label="处理状态" width="100" show-overflow-tooltip>
												<template #default="scope">
													<span v-if="scope.row.isedit==1">
														<el-button type="primary" style="" @loading="dialogTableVisibleLoading" @click="agreestorage(1,item.id)">确认</el-button>
													</span>
													<span v-else-if="scope.row.isedit==2">
														已拒绝
													</span>
													<span v-else-if="scope.row.isedit==3">
														已同意
													</span>
												</template>
											</el-table-column>
										</el-table>
									</div>
									<div style="margin-top:5px">
										<el-table :data="item.adminGridData" border :header-cell-style="{'background-color': '#e5e5e5'}" size="small" style="width: 100%">
											<el-table-column property="date" label="可能" width="60" />
											<el-table-column property="admin_brand_name" label="品牌" width="100" show-overflow-tooltip>
												<template #default="scope">
													<span v-bind:style="{ color:scope.row.admin_brand_name==item.gridData[0]['brand_name']?'#000':'red'  }">
														{{scope.row.admin_brand_name}}
													</span>
												</template>
											</el-table-column>
											<el-table-column property="admin_name" label="品名" width="100" show-overflow-tooltip>
												<template #default="scope">
													<span v-bind:style="{ color:scope.row.admin_name==item.gridData[0]['name']?'#000':'red'  }">
														{{scope.row.admin_name}}
													</span>
												</template>
											</el-table-column>
											<el-table-column property="admin_model" label="型号" show-overflow-tooltip>
												<template #default="scope">
													<span v-bind:style="{ color:scope.row.admin_model==item.gridData[0]['model']?'#000':'red'  }">
														{{scope.row.admin_model}}
													</span>
												</template>
											</el-table-column>
											<el-table-column property="admin_order_no" label="订货号" show-overflow-tooltip>
												<template #default="scope">
													<span v-bind:style="{ color:scope.row.admin_order_no==item.gridData[0]['order_no']?'#000':'red'  }">
														{{scope.row.admin_order_no}}
													</span>
												</template>
											</el-table-column>
											<el-table-column property="admin_stock_type_txt" label="货物状态" width="160" show-overflow-tooltip>
												<template #default="scope">
													<span v-bind:style="{ color:scope.row.admin_stock_type_txt==item.gridData[0]['stock_type_txt']?'#000':'red'  }">
														{{scope.row.admin_stock_type_txt}}
													</span>
												</template>
											</el-table-column>
											<el-table-column property="admin_remark" label="备注" show-overflow-tooltip>
												<template #default="scope">
													<span v-bind:style="{ color:scope.row.admin_remark==item.gridData[0]['remark']?'#000':'red'  }">
														{{scope.row.admin_remark}}
													</span>
												</template>
											</el-table-column>
											<el-table-column property="pro_result" width="100" show-overflow-tooltip>
												<template #default="scope">
													<span v-if="scope.row.isedit==1">
														<el-button type="danger" style="" @loading="dialogTableVisibleLoading" @click="agreestorage(2,item.id)">
															拒绝
														</el-button>
													</span>
												</template>
											</el-table-column>
										</el-table>
									</div>
								</el-col>
							</el-row>
						</el-card>
						<!-- <el-table :data="tableData" @row-dblclick="rowDblclick" row-key="key" :row-style="addStyle" :height="tableHeight" ref="singleTable" :header-cell-style="header_table" size="small" style="width: 100%" v-loading="loading">
							<el-table-column prop="header" label="">
								<template #header>
								
							    </template>
								<el-table-column type="selection" width="55" />
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
								</template>
								<el-table-column prop="key" label="行号" width="55" />
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
									<el-input v-model="form.brand_name" placeholder="品牌">
									</el-input>
								</template>
								<el-table-column prop="brand_name" label="品牌" width="90" show-overflow-tooltip />
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
									<el-input v-model="form.name" placeholder="品名">
									</el-input>
								</template>
								<el-table-column prop="name" label="品名" width="150" show-overflow-tooltip />
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
									<el-input v-model="form.model" placeholder="型号">
									</el-input>
								</template>
								<el-table-column prop="model" label="型号" width="150" show-overflow-tooltip />
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
									<el-input v-model="form.order_no" placeholder="订货号">
									</el-input>
								</template>
								<el-table-column prop="order_no" label="订货号" width="150" show-overflow-tooltip />
							</el-table-column>
							<el-table-column prop="header" label="">
								<el-table-column prop="num" label="数量" width="60" show-overflow-tooltip />
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
									<el-select v-model="form.stock_type_txt" placeholder="货物状态" clearable>
										<el-option :label="item.value" v-for="(item,index) in stock_type_txt_list" :value="item.value" />
									</el-select>
								</template>
								<el-table-column prop="stock_type_txt" label="货物状态" width="160" show-overflow-tooltip>
								</el-table-column>
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
									<el-input v-model="form.remark" placeholder="备注">
										<template #append>
											<el-button type="primary" class="button" style="width:60px" @click="grabble">
												<el-icon color="#fff" size="12px" class="no-inherit">
													<Search />
												</el-icon>
											</el-button>
										</template>
									</el-input>
								</template>
								<el-table-column prop="admin_remark" min-width="200" label="备注" width="" show-overflow-tooltip />
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
								</template>
								<el-table-column prop="create_time" label="提交时间" width="150" />
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
								</template>
								<el-table-column prop="pro_result" label="处理状态" width="120" >
									<template #default="scope">
										<span v-if="scope.row.isedit==1">
											未处理
										</span>
										<span v-else-if="scope.row.isedit==2">
											已拒绝
										</span>
										<span v-else-if="scope.row.isedit==3">
											已同意
										</span>
									</template>
								</el-table-column>
							</el-table-column>
							
						</el-table> -->
					</div>
				</el-col>
				<el-col :span="24" class="page" style="display: flex; justify-content: flex-end;">
					<el-pagination :pager-count="5" size="small" class="pagination" :current-page="page" background :page-size="parseInt(page_size)" layout="prev, pager, next" @current-change="handleCurrentChange" :total="total">
					</el-pagination>
				</el-col>
			</el-row>
		</div>
		<el-dialog v-model="dialogTableVisible" title="确认更新" width="1200">
			<template #footer>
				<div class="dialog-footer">
				</div>
			</template>
		</el-dialog>
	</div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { shallowRef } from 'vue'
import '../../assets/user/index.css' //优化表格样式
export default {
	components: {},
	data() {

		return {
			tableHeight: 300,
			gridData: shallowRef([]),
			adminGridData: shallowRef([]),
			dialogTableVisible: false,
			dialogTableVisibleLoading: false,
			tableData: [],
			stock_type_txt_list: [{
					text: '滞纳、在保、包附完好',
					value: '滞纳、在保、包附完好'
				},
				{
					text: '滞纳、在保、包附破损',
					value: '滞纳、在保、包附破损'
				},
				{
					text: '滞纳、过保、包附完好',
					value: '滞纳、过保、包附完好'
				},
				{
					text: '滞纳、过保、包附破损',
					value: '滞纳、过保、包附破损'
				},
				{
					text: '二手、在保、包附完好',
					value: '二手、在保、包附完好'
				},
				{
					text: '二手、在保、包附破损',
					value: '二手、在保、包附破损'
				},
				{
					text: '二手、过保、包附完好',
					value: '二手、过保、包附完好'
				},
				{
					text: '二手、过保、包附破损',
					value: '二手、过保、包附破损'
				}
			],
			form: {
				name: '',
				userinfo: '',
				type: '',
			},
			loading: false,
			total: 0,
			page: 1,
			page_size: 120,
			user_id: '',

		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {
		this.search()
		this.tableHeight_fun()
		this.user_id = localStorage.getItem('user_id');
	},
	watch: {

	},
	methods: {
		addStyle({ row, rowIndex }) {
			if (row.isedit == 1) {
				return { 'color': 'red' }
			} else {

			} /**/
		},
		agreestorage(info, id) {
			this.agreestorage_ajax(info, id)
		},
		async agreestorage_ajax(info, id) {
			this.dialogTableVisibleLoading = true
			await this.$axios.post('/api/yunsys.storage/agreestorage', { ids: [id], type: info }).then(async (res) => {
					this.dialogTableVisibleLoading = false
					var res = res.data;
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.dialogTableVisible = false;
					this.$fetchDataPeriodically();
					this.grabble();
					return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})

				})
				.catch(err => {
					this.dialogTableVisibleLoading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},

		header_table(event) {
			if (event.column.property == 'header') {
				return { 'background-color': '#fff' }
			} else {
				return { 'background-color': '#e5e5e5' }
			}

		},
		grabble() {
			this.page = 1;
			this.search();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.search();
		},
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 100
			})
		},
		rowDblclick(row) {
			console.log(row)
			this.dialogTableVisible = true;
			this.gridData = [{
				id: row.id,
				brand_name: row.brand_name,
				name: row.name,
				model: row.model,
				order_no: row.order_no,
				stock_type_txt: row.stock_type_txt,
			}]
			this.adminGridData = [{
				id: row.id,
				admin_brand_name: row.admin_brand_name,
				admin_name: row.admin_name,
				admin_model: row.admin_model,
				admin_order_no: row.admin_order_no,
				admin_stock_type_txt: row.admin_stock_type_txt,
				admin_remark: row.admin_remark,
			}]
		},
		async search() {
			this.loading = true
			var search = this.form;
			search.page = this.page;
			search.ps = this.page_size;
			await this.$axios.post('/api/yunsys.storage/getchangestorage', search).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					var obj = this;
					this.total = res.data.total;
					var key = 0;
					res.data.data.forEach(item => {
						key = key + 1
						item.key = (obj.page - 1) * obj.page_size + key
						item.gridData = [{
							id: item.id,
							brand_name: item.brand_name,
							name: item.name,
							model: item.model,
							order_no: item.order_no,
							stock_type_txt: item.stock_type_txt,
							isedit: item.isedit,
						}]
						item.adminGridData = [{
							id: item.id,
							admin_brand_name: item.admin_brand_name,
							admin_name: item.admin_name,
							admin_model: item.admin_model,
							admin_order_no: item.admin_order_no,
							admin_stock_type_txt: item.admin_stock_type_txt,
							isedit: item.isedit,
							admin_remark: item.admin_remark,
						}]

					})
					this.tableData = res.data.data;
					console.log(this.tableData)
				})
				.catch(err => {
					console.log(err)
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		}
	}
}
</script>
<style lang="less" scoped>
:deep(.el-table__header .el-table__cell) {}

:deep(.el-card__body) {
	padding: 5px
}

:deep(.el-card) {
	margin-right: 5px;
}

:deep(.table thead tr:first-child .cell) {}

/* 小屏幕 (平板, 768px 及以上) */
@media (min-width: 768px) {
	.search_remark {
		width: 120px;
	}
}

/* 中等屏幕 (桌面, 992px 及以上) */
@media (min-width: 992px) {
	.search_remark {
		width: 170px;
	}
}

/* 大屏幕 (大桌面, 1600px 及以上) */
@media (min-width: 1600px) {
	.search_remark {
		width: 400px;
		margin-left: 60px
	}
}

/* 超大屏幕 (更大桌面, 1920px 及以上) */
@media (min-width: 1920px) {
	.search_remark {
		width: 400px;
		margin-left: 60px
	}
}
</style>